module.exports = __webpack_public_path__ + "img/specials-multislider-kia.891d8d64.png";